import i18n from '@/libs/i18n'

export default [
  {
    id: 5,
    name: i18n.tc('timeout.5minutes'),
  },
  {
    id: 10,
    name: i18n.tc('timeout.10minutes'),
  },
  {
    id: 15,
    name: i18n.tc('timeout.15minutes'),
  },
  {
    id: 20,
    name: i18n.tc('timeout.20minutes'),
  },
  {
    id: 25,
    name: i18n.tc('timeout.25minutes'),
  },
  {
    id: 30,
    name: i18n.tc('timeout.30minutes'),
  },
  {
    id: 35,
    name: i18n.tc('timeout.35minutes'),
  },
  {
    id: 40,
    name: i18n.tc('timeout.40minutes'),
  },
  {
    id: 45,
    name: i18n.tc('timeout.45minutes'),
  },
  {
    id: 50,
    name: i18n.tc('timeout.50minutes'),
  },
  {
    id: 55,
    name: i18n.tc('timeout.55minutes'),
  },
  {
    id: 60,
    name: i18n.tc('timeout.1hour'),
  },
]
